"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateEvmTransactionDetails = exports.parseChainId = exports.encodeAnyEthSecp256k1PubKey = exports.PUBLIC_KEY_SIGNING_TEXT = exports.ETH_SECP256K1_TYPE = void 0;
const codec_1 = require("../codec");
const keys_1 = require("../codec/ethermint/crypto/v1/ethsecp256k1/keys");
const constant_1 = require("../constant");
const ethers_1 = require("ethers");
exports.ETH_SECP256K1_TYPE = '/ethermint.crypto.v1.ethsecp256k1.PubKey';
exports.PUBLIC_KEY_SIGNING_TEXT = 'Sign your public key to merge your Carbon account: ';
function encodeAnyEthSecp256k1PubKey(pubkey) {
    const ethPubKey = keys_1.PubKey.fromPartial({
        key: pubkey,
    });
    return codec_1.Any.fromPartial({
        typeUrl: exports.ETH_SECP256K1_TYPE,
        value: keys_1.PubKey.encode(ethPubKey).finish(),
    });
}
exports.encodeAnyEthSecp256k1PubKey = encodeAnyEthSecp256k1PubKey;
function parseChainId(evmChainId) {
    const chainId = evmChainId.trim();
    if (chainId.length > 48) {
        throw new Error(`chain-id '${chainId}' cannot exceed 48 chars`);
    }
    if (!chainId.match(/^[a-z]+_\d+-\d+$/)) {
        throw new Error(`chain-id '${chainId}' does not conform to the required format`);
    }
    return chainId.split("_")[1].split("-")[0];
}
exports.parseChainId = parseChainId;
function populateEvmTransactionDetails(api, req) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new ethers_1.ethers.providers.JsonRpcProvider(constant_1.NetworkConfigs[api.network].evmJsonRpcUrl);
        const evmHexAddress = (_b = (_a = api.wallet) === null || _a === void 0 ? void 0 : _a.evmHexAddress) !== null && _b !== void 0 ? _b : '';
        let request = {
            to: (_c = req.to) !== null && _c !== void 0 ? _c : '',
            from: (_d = req.from) !== null && _d !== void 0 ? _d : (_e = api.wallet) === null || _e === void 0 ? void 0 : _e.evmHexAddress,
            nonce: (_f = req.nonce) !== null && _f !== void 0 ? _f : (yield provider.getTransactionCount(evmHexAddress)),
            data: req.data,
            value: req.value ? `0x${Number(req.value).toString(16)}` : undefined,
            chainId: (_g = req.chainId) !== null && _g !== void 0 ? _g : Number(parseChainId(yield ((_h = api.wallet) === null || _h === void 0 ? void 0 : _h.getEvmChainId()))),
            // type = 0, 1 or 2 where 0 = legacyTx, 1 = AccessListTx, 2 = DynamicTx. Defaults to DynamicTx 
            type: (_j = req.type) !== null && _j !== void 0 ? _j : 2,
            accessList: req.accessList,
        };
        const gasLimit = (yield provider.estimateGas(request)).toHexString();
        const gasFee = yield provider.getFeeData();
        if (!req.gasPrice) {
            // Dynamic Tx
            return Object.assign(Object.assign({}, request), { maxPriorityFeePerGas: (_k = req.maxPriorityFeePerGas) !== null && _k !== void 0 ? _k : (_l = gasFee.maxPriorityFeePerGas) === null || _l === void 0 ? void 0 : _l.toHexString(), maxFeePerGas: (_m = req.maxFeePerGas) !== null && _m !== void 0 ? _m : (_o = gasFee.maxFeePerGas) === null || _o === void 0 ? void 0 : _o.toHexString(), gasLimit, type: 2 });
        }
        if (req.accessList) {
            // AccessList Tx 
            return Object.assign(Object.assign({}, request), { gasLimit, type: 1 });
        }
        // LegacyTx
        return Object.assign(Object.assign({}, request), { gasLimit, type: 0 });
    });
}
exports.populateEvmTransactionDetails = populateEvmTransactionDetails;
